import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PendingIndicator from '4ff-lib-foundation/lib/components/PendingIndicator';
import BreadcrumbsItem from '../BreadcrumbsItem';
import queryString from '../../services/queryString';
import history from '../../services/history';

class Redirect extends PureComponent {
  static propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    const query = queryString.parse(this.props.location.search);
    if (query.url) {
      window.location.href = query.url;
    } else {
      history.push('/404');
    }
  }

  render() {
    return (
      <>
        <BreadcrumbsItem to="/dashboard">Redirect</BreadcrumbsItem>
        <PendingIndicator />
      </>
    );
  }
}

export default Redirect;
